import { LanguageSettingContentProps } from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/LanguageSetting';
import React, { useState } from 'react';
import {
  Language,
  LanguageValue,
  MyInfo,
  SelectableLanguages,
} from '@/types/api';
import { useDialog } from '@/hooks/global-tools';
import { useChangeLanguage } from '@/hooks/apiHooks';
import { RnMessage, sendToRN } from '@/utils/function';
import { useRouter } from 'next/router';

const useLanguageSettingContentProps = ({
  myInfo: { language = 'ko' },
}: {
  myInfo: MyInfo;
}): LanguageSettingContentProps => {
  const router = useRouter();
  const dialog = useDialog();

  const [selectedLanguage, setSelectedLanguage] =
    useState<LanguageValue>(language);

  const [isLoading, setIsLoading] = useState(false);

  const handleSelect = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string,
  ) => {
    setSelectedLanguage(value as LanguageValue);
  };

  const handleChange = async () => {
    setIsLoading(true);
    try {
      await useChangeLanguage(selectedLanguage);
      if (window.isRNWebview) {
        sendToRN(RnMessage.RESTART);
      } else {
        router.reload();
      }
    } catch (e) {
      dialog?.showError({
        e,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    language,
    selectedLanguage,
    selectOptions: SelectableLanguages.map((item) => ({
      value: item,
      label: Language[item],
    })),
    handleSelect,
    handleChange,
    isChangeButtonDisabled: selectedLanguage === language,
    isLoading,
  };
};

export default useLanguageSettingContentProps;
